export class OurSolutions extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.accordionHandler = this.handleAccordionChange.bind(this);
  }

  connectedCallback() {
    this.initScrollAnimation();
    this.initAccordionToggle();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.removeAccordionListeners();
  }

  handleAccordionChange(e) {
    const checkbox = e.target;
    // If this checkbox is being checked, uncheck all others
    if (checkbox.checked) {
      const checkboxes = this.querySelectorAll('.solution-card__toggle');
      checkboxes.forEach((otherCheckbox) => {
        if (otherCheckbox !== checkbox) {
          otherCheckbox.checked = false;
        }
      });
    }
    // If unchecked, no action needed (clicking same card closes it naturally)
  }

  initAccordionToggle() {
    // Accordion behavior: only one card open at a time
    const checkboxes = this.querySelectorAll('.solution-card__toggle');
    
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', this.accordionHandler);
    });
  }

  removeAccordionListeners() {
    const checkboxes = this.querySelectorAll('.solution-card__toggle');
    checkboxes.forEach((checkbox) => {
      checkbox.removeEventListener('change', this.accordionHandler);
    });
  }

  initScrollAnimation() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5 // Trigger when 50% of section is visible
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add the class that triggers animations
          this.classList.add('is-visible');
          
          // Disconnect observer after first trigger (animation plays once)
          this.observer.disconnect();
        }
      });
    }, observerOptions);

    this.observer.observe(this);
  }
}

if (!customElements.get('our-solutions')) {
  customElements.define('our-solutions', OurSolutions);
}
